import { render, staticRenderFns } from "./WalletRecharge.vue?vue&type=template&id=ce3ab06e&scoped=true&"
import script from "./WalletRecharge.vue?vue&type=script&lang=js&"
export * from "./WalletRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3ab06e",
  null
  
)

export default component.exports